var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.21298 5.25953C7.7033 3.79902 9.70978 2.98566 11.7964 2.99619C13.883 3.00673 15.8812 3.84032 17.3567 5.31581C18.8322 6.7913 19.6658 8.78946 19.6763 10.8761C19.6869 12.9627 18.8735 14.9692 17.413 16.4595L13.227 20.6455C12.8519 21.0205 12.3433 21.2311 11.813 21.2311C11.2827 21.2311 10.774 21.0205 10.399 20.6455L6.21298 16.4595C4.72787 14.9743 3.89355 12.9599 3.89355 10.8595C3.89355 8.75915 4.72787 6.74479 6.21298 5.25953Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.813 13.8594C13.4698 13.8594 14.813 12.5162 14.813 10.8594C14.813 9.20252 13.4698 7.85938 11.813 7.85938C10.1561 7.85938 8.81299 9.20252 8.81299 10.8594C8.81299 12.5162 10.1561 13.8594 11.813 13.8594Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/Location_Icon.55bc75f7565c2db8cb874ab99f627f8b.svg";
export { ForwardRef as ReactComponent };